/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import './ManagerDetail.scss';

import defaultPicture from '../../../../../../assets/images/prof.svg';

const ManagerDetail = ({onCloseClick}) => {
  const manager = useSelector((state) => state.customer ? state.customer.relationshipManager : null);

  function onClickOutside(event) {
    const ourRoot = this.domRoot;

    // just in case our root got cleared or not set, trigger close if click in that situation
    if (ourRoot === undefined) {
      onCloseClick(event);
      return;
    }

    let target = event.target;
    do {
      if (target === ourRoot) {
        // click inside, ignore
        return;
      }
    } while (target !== undefined && (target = target.parentElement));

    // if we got here, we clicked outside
    onCloseClick(event);
  }
  /* eslint-disable */
  useEffect(() => {
    document.addEventListener('click', onClickOutside);
    return document.addEventListener('click', onClickOutside);
  }, []);
  /* eslint-enable */

  const rmProfileUrl ='';
  const managerImage = _.isEmpty(manager.pictureUrl) ? defaultPicture : manager.pictureUrl;
  const managerProfile = _.toLower(rmProfileUrl({firstName: manager.firstName, lastName: manager.lastName}));
  const mailToPrefix = 'mailto:' + manager.officeEmail;
  const telPrefix = 'tel:+'+ _.replace(manager.officePhone, '-', '');
  return (
    <div id="manager-detail" ref={domRoot => this.domRoot = domRoot}>
      <div className="heading">
        <div className="image-cropper" style={{backgroundImage: `url(${managerImage})`}}>
        </div>
        <div className="info">
          <p className="name blocked_data">{ manager.fullName }</p>
          <p className="title">{ manager.jobTitle }</p>
          <p className="title">{ manager.officeLocation }</p>
          <p className="title profile"><a target="_blank" rel="noopener noreferrer" href={managerProfile}>View Profile</a></p>
        </div>
      </div>
      <div className="detail">
        <div className="greeting blocked_data">
          <p>Hello, I'm {manager.firstName} {manager.lastName}, your Account Team. Please contact me with any questions or needs you may have related to your account. I'm here to help.</p>
        </div>

        <div className="line">
          <label>Toll Free</label>
          <p className="phone"><a href={telPrefix}>{ manager.officePhone }</a></p>
        </div>
        <div className="line">
          <label>Email</label>
          <p className="email"><a href={mailToPrefix} className='blocked_data'>{ manager.officeEmail }</a></p>
        </div>
      </div>
    </div>
  );
};

ManagerDetail.propTypes = {
  manager: PropTypes.object
};

export default ManagerDetail;